export const bondPriceConvert = (priceFactor: number) => (currentPrice: number) => {
  const thousanths = currentPrice % 1
  let price = thousanths * 32
  switch (priceFactor) {
    case 32:
      price = Math.round(price) * 10
      break;
    case 64:
      price = price * 10
      price = Math.round(price / 5) * 5;
      break;
  }
  let thous = Math.round(price).toString()
  // let thous = (Math.round((Number((currentPrice % 1).toFixed(4)) * conversionFactor)) * 10).toString();
  while (thous.length < 3) {thous = '0' + thous};
  return Number(Math.floor(currentPrice).toString() + thous);
}

export const marketPriceConvert = (currentPrice: number) => currentPrice

export interface ISymbolConfig {
	id: string,
	label: string,
	baseSymbol: string,
	model: string,
}

interface IPeriodicityOptions {
	period: number,
	interval: number,
	timeUnit: string,
	label: string,
}

interface IChartTypeInputs {
	lookup: string
	label: string
}

interface IChartTypes {
	type: string,
	label: string,
	aggregationEdit?: {
		title: string,
		inputs: IChartTypeInputs[],
	},
}

export interface IDisplaySetting {
	decimalPlaces: number
	priceConverter: (currentPrice: number) => number
	pricingTerm: string
	type: 'market' | 'bond'

}

interface IDisplaySettings {
	[key: string]: IDisplaySetting
}

interface IConfig {
	displaySettings: IDisplaySettings
	symbols: ISymbolConfig[]
	periodicity: {
		options: IPeriodicityOptions[]
	}
	chartTypes: {
		types: IChartTypes[]
	}
}

const configs: IConfig =
{
	chartTypes: {
		types: [{
			label: 'Bar',
			type: 'bar',
		}, {
			label: 'Candle',
			type: 'candle',
		}, {
			label: 'Colored bar',
			type: 'colored_bar',
		}, {
			label: 'Hollow candle',
			type: 'hollow_candle',
		}, {
			label: 'Line',
			type: 'line',
		}, {
			label: 'Mountain',
			type: 'mountain',
		}, {
			label: 'Volume candle',
			type: 'volume_candle',
		}, {
			label: 'Heikin-Ashi',
			type: 'heikinashi',
		}, {
			aggregationEdit: {
				inputs: [{
					label: 'Kagi',
					lookup: 'kagi',
				}],
				title: 'Set Reversal Percentage',
			},
			label: 'Kagi',
			type: 'kagi',
		}, {
			aggregationEdit: {
				inputs: [{
					label: 'Price line',
					lookup: 'priceLines',
				}],
				title: 'Set Price Lines',
			},
			label: 'Line break',
			type: 'linebreak',
		}, {
			aggregationEdit: {
				inputs: [{
					label: 'Renko',
					lookup: 'renko',
				}],
				title: 'Set Range',
			},
			label: 'Renko',
			type: 'renko',
		}, {
			aggregationEdit: {
				inputs: [{
					label: 'Range',
					lookup: 'range',
				}],
				title: 'Set Range',
			},
			label: 'Range bars',
			type: 'rangebars',
		}, {
			aggregationEdit: {
				inputs: [{
					label: 'Box',
					lookup: 'pandf.box',
				}, {
					label: 'Reversal',
					lookup: 'pandf.reversal',
				}],
				title: 'Set Point & Figure Parameters',
			},
			label: 'Point & figure',
			type: 'pandf',
		}],
	},
	displaySettings: {
		es: {
			decimalPlaces: 2,
			priceConverter: marketPriceConvert,
			pricingTerm: 'pt',
			type: 'market',
		},
		nq: {
			decimalPlaces: 2,
			priceConverter: marketPriceConvert,
			pricingTerm: 'pt',
			type: 'market',
		},
		spx: {
			decimalPlaces: 2,
			priceConverter: marketPriceConvert,
			pricingTerm: 'pt',
			type: 'market',
		},
		zb: {
			decimalPlaces: 0,
			priceConverter: bondPriceConvert(32),
			pricingTerm: 'ZB ticks',
			type: 'bond',
		},
		zn: {
			decimalPlaces: 0,
			priceConverter: bondPriceConvert(64),
			pricingTerm: 'ZN ticks',
			type: 'bond',
		}
	},
	periodicity: {
		options: [{
			interval: 1,
			label: 'ticks',
			period: 1,
			timeUnit: 'tick'
		},{
      interval: 1,
			label: '1 sec',
			period: 1,
      timeUnit: 'second',
		}, {
      interval: 5,
      label: '5 sec',
      period: 1,
      timeUnit: 'second'
    }, {
      interval: 1,
			label: '1 Min',
			period: 1,
      timeUnit: 'minute',
		},
		// {
		// 	interval: 1,
		// 	label: '5 Min',
		// 	period: 5,
    //   timeUnit: 'minute',
		// }, {
		// 	interval: 1,
		// 	label: '10 Min',
		// 	period: 10,
    //   timeUnit: 'minute',
		// }, {
		// 	interval: 1,
		// 	label: '15 Min',
		// 	period: 15,
    //   timeUnit: 'minute',
		// },
		 {
			interval: 1,
			label: '1 Hour',
			period: 1,
      timeUnit: 'hour',
		},
		// {
		// 	interval: 1,
		// 	label: '4 Hour',
		// 	period: 4,
    //   timeUnit: 'hour',
		// },
		{
			interval: 1,
			label: '1 Day',
			period: 1,
      timeUnit: 'day',
		},
		// {
		// 	interval: 1,
		// 	label: '2 Day',
		// 	period: 2,
    //   timeUnit: 'day',
		// }, {
		// 	interval: 1,
		// 	label: '3 Day',
		// 	period: 3,
    //   timeUnit: 'day',
		// }, {
		// 	interval: 1,
		// 	label: '5 Day',
		// 	period: 5,
    //   timeUnit: 'day',
		// }, {
		// 	interval: 1,
		// 	label: '10 Day',
		// 	period: 10,
    //   timeUnit: 'day',
		// }, {
		// 	interval: 1,
		// 	label: '20 Day',
		// 	period: 20,
    //   timeUnit: 'day',
		// }
	],
	},
	symbols: [{
    baseSymbol: 'ES',
    id: 'VPMES1',
    label: 'ES 1',
    model: 'VPMES1',
  }, {
    baseSymbol: 'ES',
    id: 'VPMES5',
    label: 'ES 5',
    model: 'VPMES5',
  },{
    baseSymbol: 'ES',
    id: 'VPMES60',
    label: 'ES 60',
    model: 'VPMES60',
  }, {
    baseSymbol: 'ES',
    id: 'VPMES5F',
    label: 'ES 5 F',
    model: 'VPMES5F',
  }, {
    baseSymbol: 'ES',
    id: 'VPMES60F',
    label: 'ES 60 F',
    model: 'VPMES60F',
  }, {
    baseSymbol: 'NQ',
    id: 'VPMNQ1',
    label: 'NQ 1',
    model: 'VPMNQ1',
  }, {
    baseSymbol: 'NQ',
    id: 'VPMNQ5',
    label: 'NQ 5',
    model: 'VPMNQ5',
  }, {
    baseSymbol: 'NQ',
    id: 'VPMNQ60',
    label: 'NQ 60',
    model: 'VPMNQ60',
  }, {
    baseSymbol: 'NQ',
    id: 'VPMNQ5F',
    label: 'NQ 5 F',
    model: 'VPMNQ5F',
  }, {
    baseSymbol: 'NQ',
    id: 'VPMNQ60F',
    label: 'NQ 60 F',
    model: 'VPMNQ60F',
  }, {
    baseSymbol: 'ZB',
    id: 'VPMZB1',
    label: 'ZB 1',
    model: 'VPMZB1',
  }, {
    baseSymbol: 'ZB',
    id: 'VPMZB1',
    label: 'ZB 5',
    model: 'VPMZB1',
  }, {
    baseSymbol: 'ZB',
    id: 'VPMZB60',
    label: 'ZB 60',
    model: 'VPMZB60',
  }, {
    baseSymbol: 'ZB',
    id: 'VPMZB5F',
    label: 'ZB 5 F',
    model: 'VPMZB5F',
  }, {
    baseSymbol: 'ZB',
    id: 'VPMZB60F',
    label: 'ZB 60 F',
    model: 'VPMZB60F',
  }, {
    baseSymbol: 'ZN',
    id: 'VPMZN1',
    label: 'ZN 1',
    model: 'VPMZN1',
  }, {
    baseSymbol: 'ZN',
    id: 'VPMZN1',
    label: 'ZN 5',
    model: 'VPMZN1',
  }, {
    baseSymbol: 'ZN',
    id: 'VPMZN60',
    label: 'ZN 60',
    model: 'VPMZN60',
  }, {
    baseSymbol: 'ZN',
    id: 'VPMZN5F',
    label: 'ZN 5 F',
    model: 'VPMZN5F',
  }, {
    baseSymbol: 'ZN',
    id: 'VPMZN60F',
    label: 'ZN 60 F',
    model: 'VPMZN60F',
  }, {
    baseSymbol: 'CL',
    id: 'VPMCL1',
    label: 'CL 1',
    model: 'VPMCL1',
  }, {
    baseSymbol: 'CL',
    id: 'VPMCL1',
    label: 'CL 5',
    model: 'VPMCL1',
  }, {
    baseSymbol: 'CL',
    id: 'VPMCL60',
    label: 'CL 60',
    model: 'VPMCL60',
  }, {
    baseSymbol: 'CL',
    id: 'VPMCL5F',
    label: 'CL 5 F',
    model: 'VPMCL5F',
  }, {
    baseSymbol: 'CL',
    id: 'VPMCL60F',
    label: 'CL 60 F',
    model: 'VPMCL60F',
  }, {
    baseSymbol: 'CL',
    id: 'VPMCL60',
    label: 'CL 60',
    model: 'VPMCL60',
  }],
};
export default configs;
